import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import OperationListEditor from './OperationListEditor';
import {CurrencyFormatter, ProductColumn, UnitFormatter} from "../../../utils/formatters";
import {postData} from "../../../utils/request";
import React, {Fragment} from "react";
import TextInput from "../../form/TextInput";
import {ifCompletedInput} from "../../../utils/other";
import isEqual from 'lodash-es/isEqual';
import Button from "../../form/Button";
import ConsignmentReturnForm from "./Elements/ConsignmentReturnForm";
import CheckBox from "../../form/CheckBox";
import {Tooltip} from "react-tippy";
import {PriceView} from "../../classes/Price";

const sortable = true;
const filterable = true;

class ConsignmentReturnEditor extends React.Component {

    state = {
        filtered: false,
        componentEditor: "ConsignmentReturn",
        filter: [
            {column: "preset", value: "ConsignmentReturn"},
            {column: "saved", value: 1}
        ],
        labels: {customer: "Partner"},
        actionButtons: [],
        pool: {
            orderBy: {field: "displayname", direction: "ASC"},
            sortBy: [{field: "stockqty", direction: "ASC"}],
            visible: false,
            selection: [],
            pageSize: 5,
            pageSizes: [5,10,15,20,50],
            aggregations: {
                fields: {
                    "count": {
                        field: "pickedqty", type: "COUNT"
                    },
                    "pickedqty": {
                        field: "pickedqty", type: "SUM"
                    },
                }
            },
            component: "OperationProductPoolItem",
            view: ["id","product_id","OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice"],
            columns: {
                "displayname": {
                    ...ProductColumn("component_id"),
                    width: 1,
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 1,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Lista ár',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: CurrencyFormatter
                },
                "stockqty": {
                    header: 'Készlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "consignment_first_transfer": {
                    header: 'Első szállítás',
                    width: 1,
                    sortable,
                    filterable,
                },
                "consignment_stockqty": {
                    header: 'Bizományos készlet',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "saleqty": {
                    header: 'Eladott mennyiség',
                    width: 1,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                "pickedqty": {
                    header: "Darabszám",
                    width: 1,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    sortable,
                    filterable,
                    aggregation: (value, row) => {
                        return <Fragment><span className="unit">Összesen: {UnitFormatter(row.pickedqty || 0, row.unit).props.children}</span><span className="unit">Tétel: {UnitFormatter(row.count || 0, row.unit).props.children}</span></Fragment>;
                    },
                    className: "unit",
                    editor:
                        (parent) =>
                            (props, value) =>
                                <TextInput type="number" name="pickedqty" label={false} focus value={value}
                                           onKeyDown={(e, field, value) => {ifCompletedInput(e) && parent.onEditorValueChange(props, value);}}
                                           onBlur={(e, field, value) => parent.onEditorValueChange(props, value)}/>
                },
            }
        }
    };

    promisedSetState = (newState) => {
        return new Promise((resolve) => {
            this.setState(newState, () => {
                resolve()
            });
        });
    }

    constructor(props) {
        super(props);
    }

    setFieldValue = (field, value) => {
        this.props.setFieldValue(field, value);
        if (field === "customer" && !isEqual(value, this.props.values.customer)) {
            this.props.setFieldValue("target", null);
        }
    }

    getProps = () => {
        const props = {
            ...this.props,
            ...this.state,
            setFieldValue: this.setFieldValue,
        };
        props.actionButtons = [
            <Button key="4" disabled={ props.isLoading || !props.values.id } color="primary" icon={{lib: "fa", name: "truck"}} className="pull-right" onClick={ async (e) => {
                const values = props.values;
                values.autocheckup = true;
                await props.processAction(async () => {
                    const response = await postData({
                        action: 'OperationList.doAction',
                        actionname: 'create',
                        data: await referenceActionData(values, this.props.componentConfig)
                    });
                    await this.props.pristineForm(false);
                    return response;
                });
            }}>
                Szállítás
            </Button>
        ];
        props.pool.parameters = {};
        props.pool.reqparams = {};
        props.pool.filter = [{field: "consignment_stockqty", value: 0, operator: ">"}];
        if (props.values && props.values.source && props.values.customer) {
            props.pool.visible = true;
            props.pool.parameters.discount_type = "consignment";
            props.pool.parameters.partner = props.values.customer.partner_id;
            props.pool.parameters.store = props.values.source.id;
            props.pool.parameters.OperationList_id = props.values.id;
            props.pool.parameters.seller = props.values.seller.partner_id;
            props.pool.parameters.customer = props.values.customer.partner_id;
            props.pool.parameters.store_partner = props.values.seller.partner_id;
            props.pool.parameters.startdate = (props.values.xtradata || {}).startdate;
            props.pool.parameters.enddate = (props.values.xtradata || {}).enddate;
            props.pool.columns.stockqty.header = (props.values.source || {}).name || props.pool.columns.stockqty.header;
        } else {
            props.pool.visible = false;
        }
        props.filtered = this.state.filtered;
        if (this.state.filtered) {
            props.pool.filter = [...props.pool.filter, {field: "pickedqty", operator: "not isnull"}];
        } else {
            props.pool.filter = [...props.pool.filter];
        }
        props.pool.paginatorRight = (props) => {
            return <Fragment>
                <Tooltip title={!this.state.filtered ? "Csak a kiválasztottakat mutasd" : "Mindent mutat"}><CheckBox
                    onIcon={{lib: "fa", name: "box"}}
                    offIcon={{lib: "fa", name: "box-open"}}
                    value={1}
                    checked={this.state.filtered}
                    label={false}
                    saveChanges={(field, value) => {
                        this.setState({filtered: !!value});
                    }}
                    {...props}
                /></Tooltip>
            </Fragment>
        };
        return props;
    }

    renderer = (componentProps) => {
        return <ConsignmentReturnForm {...componentProps} />;
    }

    render() {
        const props = this.getProps();
        return <OperationListEditor {...props} renderer={this.renderer} />;
    }

}

export default createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: ConsignmentReturnEditor,
    editor: "ConsignmentReturn",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        componentActions: async (action, data, params, componentConfig) => {
            params.preset = "ConsignmentReturn";
            data = await referenceActionData(data, componentConfig);
            return {action,data,params};
        }
    }
});